import React, { useState } from 'react';
import CommonButton from '../components/common/button/Button';
import CommonInput from '../components/common/input/InputBox';
import { Divider, Grid } from '@mui/material';
import signUpImage from '../components/common/Images/Group.webp';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from 'axios';

const SignUp: React.FC<any> = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('translation');
    const [loading, setLoading] = useState<boolean>(false);
    //@ts-ignore
    const config = window.config;
    const apiBaseURL = config?.server || 'http://18.217.95.31:8080';

    const validationSchema = yup.object().shape({
        firstName: yup
            .string()
            .required(t('firstNameRequired')),
        lastName: yup
            .string()
            .required(t('lastNameRequired')),
        email: yup
            .string()
            .email(t('invalidEmail'))
            .required(t('emailRequired')),
        password: yup
            .string()
            .min(6, t('passwordInvalidError'))
            .max(20, t('passwordInvalidError'))
            .required(t('passwordRequired'))
    });

    const onHandleSubmit = (value: any) => {
        setLoading(true)
        const body = {
            firstName: value.firstName,
            lastName: value.lastName,
            email: value.email,
            password: value.password,
            role: "USER"
        };
        axios.post(`${apiBaseURL}/api/users/signup`, body).then((data: any) => {
            navigate('/')
        }).catch((err: any) => {
            console.log("err", err)
        }).finally(() => {
            setLoading(false);
        })

    }

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            password: ''
        },
        onSubmit: onHandleSubmit,
        validationSchema: validationSchema,
        enableReinitialize: true
    });

    const { values, errors, handleSubmit, touched, handleChange } = formik;

    return (
        <Grid className='flex justify-center h-screen items-center gap-[10%] scale-[0.75] relative'>
            <div className='flex flex-col gap-[15px] w-[40%]'>
                <Grid className="text-4xl font-[700] flex justify-center font-['IBM_Plex_Sans']">
                    {t('lotterySystem')}
                </Grid>
                <Grid className="bg-white rounded-[20px] py-[4%] font-['Baloo_2']">
                    <Grid className='flex justify-center w-full'>
                        <Grid className='text-3xl font-[500] text-[#14064C] w-[90%]'>{t('signUp')}</Grid>
                    </Grid>
                    <Grid className='flex w-full justify-center mt-4'>
                        <Grid className='w-[90%] grid grid-cols-2 gap-4'>
                            <Grid>
                                <CommonInput
                                    id="email-id-input-box"
                                    fullWidth
                                    name="firstName"
                                    label={t('firstName')}
                                    placeholder={t('firstName')}
                                    onChange={handleChange}
                                    value={values?.firstName}
                                    error={touched?.firstName && errors?.firstName ? true : false}
                                    helperText={errors?.firstName && touched?.firstName ? errors?.firstName : ""}
                                    className="login-input-box"
                                />
                            </Grid>
                            <Grid>
                                <CommonInput
                                    id="email-id-input-box"
                                    fullWidth
                                    name="lastName"
                                    label={t('lastName')}
                                    placeholder={t('lastName')}
                                    onChange={handleChange}
                                    value={values?.lastName}
                                    error={touched?.lastName && errors?.lastName ? true : false}
                                    helperText={errors?.lastName && touched?.lastName ? errors?.lastName : ""}
                                    className="login-input-box"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid className='w-full flex justify-center'>
                        <Grid className="mt-4 w-[90%]">
                            <CommonInput
                                id="email-id-input-box"
                                fullWidth
                                name="email"
                                label={t('email')}
                                placeholder={t('emailAddress')}
                                onChange={handleChange}
                                value={values?.email}
                                error={touched?.email && errors?.email ? true : false}
                                helperText={touched?.email && errors?.email ? errors?.email : ""}
                                className="login-input-box"
                            />
                        </Grid>
                    </Grid>
                    <Grid className='w-full flex justify-center'>
                        <Grid className="w-[90%]">
                            <CommonInput
                                id="password-id-input-box"
                                fullWidth
                                name="password"
                                type='password'
                                label={t('password')}
                                placeholder={t('password')}
                                onChange={handleChange}
                                value={values?.password}
                                error={touched?.password && errors?.password ? true : false}
                                helperText={errors?.password && touched?.password ? errors?.password : ""}
                                className="login-input-box"
                            />
                        </Grid>
                    </Grid>
                    <Grid className='w-full flex justify-center'>
                        <Grid className='w-[90%]'>
                            <CommonButton
                                id="login-button"
                                className="login-button"
                                variant="contained"
                                onClick={() => {
                                    handleSubmit();
                                }}
                                disabled={loading}
                            >
                                {t('createAnAccount')}
                                {loading && (
                                    <CircularProgress
                                        color="inherit"
                                        size={14}
                                        thickness={6}
                                        style={{ marginLeft: "8px" }}
                                    />
                                )}
                            </CommonButton>
                        </Grid>
                    </Grid>
                    <Grid className="w-full flex justify-center">
                        <Grid className="w-[90%]">
                            <Divider className="divider" />
                        </Grid>
                    </Grid>
                    <Grid className='flex justify-center w-full'>
                        <Grid className='flex justify-between w-[90%] items-baseline'>
                            <Grid className='text-[#474646] h-full'>{t('alreadyHaveAnAccount')}</Grid>
                            <Grid>
                                <CommonButton
                                    id="login-button"
                                    onClick={(e) => navigate('/')}
                                    className="sign-up-button"
                                    variant="outlined">
                                    {t('logIn')}
                                </CommonButton>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
            <Grid className='h-screen flex items-center align-middle w-[30%]'>
                <img src={signUpImage} alt="" className='w-full h-[70vh]' />
            </Grid>
        </Grid>
    )
}

export default SignUp;
